// router.tsx
import {
    createBrowserRouter,
    createRoutesFromElements,
    Route,
} from "react-router-dom";

import Home from "./containers/Home";
import Error404 from "./containers/Error404";
import ProdInformation from "./containers/ProdInformation";
import ProdList from "./containers/ProdList";
import Carrito from "./containers/Carrito";
import SearchProduct from "./containers/SearchProduct";
import Favorite from "./containers/Favorite";
import Offer from "./containers/Offer";
import NewProduct from "./containers/NewProduct";
import LandingSeller from "./containers/LandingSeller";
import Dashboard from './containers/Dashboard';
import UserProfile from './components/dashboard/userProfile';
import UserPurchases from './components/dashboard/userPurchases';
import UserPurchaseDetail from "./components/dashboard/userPurchaseDetail";
import BestSellingProduct from "./containers/BestSellingProduct";
import AboutUs from "./containers/AboutUs";
import TermsAndConditions from "./containers/TermsAndConditions";
import UserAddresses from "./components/dashboard/userAddresses";
import UserInvoices from "./components/dashboard/userInvoices";
import Purchases from "./containers/dashboard/Purchases";
import Productos from "./containers/dashboard/Productos";
import Store from "./containers/Store";

export const router = createBrowserRouter(
    createRoutesFromElements(
        <>
            <Route path="/" element={<Home />} />
            <Route path="/:storeSlug/:productoSlug" element={<ProdInformation />} />
            <Route path="/productos/:storeSlug" element={<ProdList />} />
            <Route path="/categoria/:catSlug" element={<ProdList />} />
            <Route path="/categoria/:catSlug/:subcatSlug" element={<ProdList />} />
            <Route path="/categoria/:catSlug/:subcatSlug/:subsubcatSlug" element={<ProdList />} />
            <Route path="/busqueda/:producto" element={<SearchProduct />} />
            <Route path="/emprendedores" element={<Store />} />
            <Route path="/:storeSlug" element={<ProdList />} />
            <Route path="mis/favoritos" element={<Favorite />} />
            <Route path="las/ofertas" element={<Offer />} />
            <Route path="las/novedades" element={<NewProduct />} />
            <Route path="los/mas-vendidos" element={<BestSellingProduct />} />
            <Route path="mi/carrito" element={<Carrito />} />
            <Route path="/vendedor" element={<LandingSeller />} />
            <Route path="/dashboard" element={<Dashboard />}>
                <Route index element={<Purchases />} />
                <Route path="perfil" element={<UserProfile />} />
                <Route path="compras" element={<Purchases />} />
                <Route path="productos" element={<Productos />} />
                <Route path="direcciones" element={<UserAddresses />} />
                <Route path="datos-facturacion" element={<UserInvoices />} />
                <Route path="compra/:codigo" element={<UserPurchaseDetail />} />
            </Route>
            <Route path="/quienes-somos" element={<AboutUs />} />
            <Route path="/terminos-y-condiciones" element={<TermsAndConditions />} />



            <Route path="*" element={<Error404 />} />
        </>
    ),
    {
        future: {
            v7_startTransition: true, // <--- Activamos el flag
        },
    }
);